import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loggedIn: sessionStorage.getItem("access_token"),
  userInfo: {},
  lastVisited: "",
  isCoordinator: false,
};

export const userSlice = createSlice({
  name: "user",
  initialState: initialState,
  reducers: {
    isLoggedIn: (state, action) => {
      return { ...state, loggedIn: action.payload };
    },
    resetAll: () => initialState,
    lastVisitedPage: (state, action) => {
      return { ...state, lastVisited: action.payload };
    },
    setCoordinatorStatus: (state, action) => {
      return { ...state, isCoordinator: action.payload };
    },
  },
});

export const { isLoggedIn, resetAll, lastVisitedPage, setCoordinatorStatus } = userSlice.actions;
export default userSlice.reducer;
